
export const outerCircleClassDefaults =
	"w-5 h-5 relative border-2 rounded-full border-brown-800 border-b-transparent border-r-transparent";
export const innerCircleClassDefaults =
	"w-3 h-3 absolute inset-0.5 border-2 rounded-full border-black-850 border-b-transparent border-r-transparent opacity-40";
export default {
	name: "CircleLoader",
	props: {
		outerCircleClass: {
			type: String,
			default: outerCircleClassDefaults,
		},
		innerCircleClass: {
			type: String,
			default: innerCircleClassDefaults,
		},
	},
};
